import gql from 'graphql-tag';

export const WAREHOUSE_PRINT_JOB_FIELDS = gql`
	fragment WarehousePrintJobFields on WarehousePrintJob {
		id
		created
		serviceDocketId
		labelType
		operationId
		isReprint
		reprintReason
		status
		statusMessage
		bridgeAcceptedAt
		completedAt
		failedAt
		uncertainAt
		warehouse {
			id
			name
		}
	}
`;

export const CREATE_WAREHOUSE_PRINT_JOB = gql`
	mutation CreateWarehousePrintJob(
		$serviceDocketId: ID!
		$labelType: WarehousePrintJobLabelType!
		$operationId: String!
	) {
		createWarehousePrintJob(
			serviceDocketId: $serviceDocketId
			labelType: $labelType
			operationId: $operationId
		) {
			...WarehousePrintJobFields
		}
	}
	${WAREHOUSE_PRINT_JOB_FIELDS}
`;

export const REPRINT_WAREHOUSE_PRINT_JOB = gql`
	mutation ReprintWarehousePrintJob($jobId: ID!, $operationId: String!, $reason: String!) {
		reprintWarehousePrintJob(jobId: $jobId, operationId: $operationId, reason: $reason) {
			...WarehousePrintJobFields
		}
	}
	${WAREHOUSE_PRINT_JOB_FIELDS}
`;

export const GET_LATEST_WAREHOUSE_PRINT_JOB = gql`
	query LatestWarehousePrintJob(
		$serviceDocketId: ID!
		$labelType: WarehousePrintJobLabelType!
	) {
		latestWarehousePrintJob(serviceDocketId: $serviceDocketId, labelType: $labelType) {
			...WarehousePrintJobFields
		}
	}
	${WAREHOUSE_PRINT_JOB_FIELDS}
`;
